import type { Purchaser } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { CreatePurchaserDTO } from "@src/domain/dto/purchasers";

export class CreatePurchaserUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(params: CreatePurchaserDTO): Promise<Purchaser> {
    return this.purchaserRepository.createPurchaser(params);
  }
}
